import { ArrowBack, Man, Woman } from "@mui/icons-material";
import { Box, Button, Card, Grid, styled } from "@mui/material";
import React, { useState } from "react";

const GenderBox = styled(Box)(({ theme }) => ({
  padding: "25px 50px",
  borderRadius: "15px",
  display: "inline-block",
  border: "1px solid #888",
  cursor: "pointer",
  margin: "20px",
  textAlign: "center",
  [theme.breakpoints.down('md')]: {
    margin: "0",
    // marginBottom:"20px"
  },
  "& svg": {
    fontSize: "75px",
  },
}));

const GenderFlex = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down('md')]: {
    flexDirection: "column",
    gap: "10px"
  },

}))

const SelectGender = ({ step, setStep, customerDetails, handleChooseGender }) => {
  const [selected, setSelected] = useState(false);

  return (
    <Card>
      <Box p={4}>
        <Box mb={4} textAlign="center">
          <h2>Gender</h2>
        </Box>
        <GenderFlex>
          <GenderBox onClick={() => handleChooseGender("Male")}>
            <p>Male</p>
            <Man color={customerDetails.gender === "Male" ? "primary" : "disabled"} />
          </GenderBox>
          <div>
            or
          </div>
          <GenderBox onClick={() => handleChooseGender("Female")}>
            <p>Female</p>
            <Woman color={customerDetails.gender === "Female" ? "primary" : "disabled"} />
          </GenderBox>
        </GenderFlex>

        <Box mt={3}>
          <Button
            size="large"
            variant="contained"
            color="secondary"
            onClick={() => setStep(step - 1)}
            style={{ marginRight: "10px" }}
          >
            <ArrowBack fontSize="small" sx={{ marginRight: "5px" }} /> Back
          </Button>
          {/* <Button
                variant="contained"
                color="primary"
                onClick={() => setStep(step + 1)}
              >
                Next
              </Button> */}
        </Box>
      </Box>
    </Card>
  );
};

export default SelectGender;
